.sidebarContent {
  opacity: 0;
  animation: sidebarSlideIn 200ms ease-in-out 200ms both;
  border-left: solid 1px var(--mantine-color-disabled-border);
}

@keyframes sidebarSlideIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
